import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, MaterialModule, ServiceResponseModule, TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';
import { ActionTabletConfirmDialogComponent } from './component/action-tablet-confirm-dialog/action-tablet-confirm.dialog.component';
import { ActionTabletHeaderStationTabComponent } from './component/action-tablet-header-station-tab/action-tablet-header-station-tab.component';
import { ActionTabletHeaderComponent } from './component/action-tablet-header/action-tablet-header.component';
import { ActionTabletMovementOrderList } from './component/action-tablet-movement-order-list/action-tablet-movement-order-list.component';
import { ActionTabletStationDetailsComponent } from './component/action-tablet-station-details/action-tablet-station-details.component';
import { ActionTabletTransportCreationProfileDetailsComponent } from './component/action-tablet-transport-creation-profile-details/action-tablet-transport-creation-profile-details.component';
import { ActionTabletWaitingMovementOrders } from './component/action-tablet-waiting-movement-orders/action-tablet-waiting-movement-orders.component';
import { ActionTabletComponent } from './component/action-tablet.component';
import { TransportOptionSelectionComponent } from './component/transport-option-selection/transport-option-selection.component';
import { ActionTabletButtonbarComponent } from './component/action-tablet-buttonbar/action-tablet-buttonbar.component';

@NgModule({
  declarations: [
    ActionTabletComponent,
    ActionTabletHeaderComponent,
    ActionTabletHeaderStationTabComponent,
    ActionTabletStationDetailsComponent,
    ActionTabletButtonbarComponent,
    ActionTabletTransportCreationProfileDetailsComponent,
    ActionTabletConfirmDialogComponent,
    ActionTabletWaitingMovementOrders,
    ActionTabletMovementOrderList,
    TransportOptionSelectionComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonLayoutModule,
    CommonUIModule,
    ReactiveFormsModule,
    FormsModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    TransportInfoPanelModule,
    TransportOptionsPanelModule
  ]
})
export class StationTabletModule { }
